export default theme => ({
  root: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'auto'
  },
  headerCell: {
    boxSizing: 'border-box',
    padding: 8,
    textAlign: 'left',
    border: `1px solid ${theme.colors.grey[100]}`,
    backgroundColor: theme.colors.grey[100],
    fontWeight: 500
  },
  rowCell: {
    padding: 8,
    textAlign: 'left',
    border: `1px solid ${theme.colors.grey[100]}`
  }
});